export default "__VITE_ASSET__DggpyCo0__"